import React from "react";
import { projects } from "../mock";
import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const Projects = () => {
  const large = projects[0];
  const small = projects.slice(1);

  return (
    <section id="projects" className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-brand-yellow text-sm font-bold tracking-[0.3em] mb-3">
              OUR RECENT PROJECTS
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-brand-dark leading-tight">
              QUALITY WORKS FOR GREAT CLIENTS
            </h2>
          </div>
          <Button
            variant="outline"
            className="border-2 border-brand-dark bg-transparent hover:bg-brand-dark hover:text-white text-brand-dark font-bold tracking-wider text-sm px-7 py-6 rounded-md group whitespace-nowrap"
          >
            VIEW ALL PROJECTS
            <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Large */}
          <div className="lg:row-span-2 group relative rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-shadow min-h-[300px]">
            <img
              src={large.image}
              alt={large.title}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
            <div className="relative h-full min-h-[520px] flex flex-col justify-end p-8 z-10">
              <div className="text-brand-yellow text-xs font-bold tracking-[0.25em] mb-2">
                {large.category}
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-white tracking-wide">
                {large.title}
              </h3>
            </div>
          </div>

          {/* Small grid */}
          {small.map((p) => (
            <div
              key={p.id}
              className="group relative rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-shadow min-h-[250px]"
            >
              <img
                src={p.image}
                alt={p.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="relative h-full min-h-[250px] flex flex-col justify-end p-6 z-10">
                <div className="text-brand-yellow text-[10px] font-bold tracking-[0.25em] mb-1">
                  {p.category}
                </div>
                <h3 className="font-display text-lg text-white tracking-wide">
                  {p.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
